<template>
  <div class="man band-card">
    <div class="nav">
      <Nav :title="navTitle" :fixed="false"></Nav>
      <div class="top"></div>
    </div>
    <van-form validate-first @submit="submit">
      <van-field
        v-model="form.certificateNo"
        required
        type="textarea"
        rows="1"
        autosize
        disabled
        size="large"
        label="证件号码"
        placeholder="请输入证件号码"
        :rules="[
          {
            required: true,
            message: '证件号码格式不正确',
            validator: certificateNoValidator,
          },
        ]"
        @blur="getIdname(form.certificateNo)"
      />
      <van-field
        v-model="form.clientName"
        required
        size="large"
        label="姓名"
        disabled
        placeholder="请输入姓名"
        :rules="[{ required: true, message: '姓名不能为空' }]"
      />
      <van-field
        label="性别"
        required
        size="large"
        :rules="[{ required: true, message: '请选择性别' }]"
      >
        <template #input>
          <van-radio-group
            v-model="form.genderId"
            direction="horizontal"
            size="large"
            disabled
          >
            <van-radio name="1">男</van-radio>
            <van-radio name="2">女</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        required
        v-model="form['age']"
        size="large"
        label="年龄"
        :placeholder="form['age']"
        disabled
      />
      <van-field
        readonly
        required
        clickable
        disabled
        size="large"
        label="出生日期"
        v-model="form['birthDay']"
        placeholder="选择出生日期"
        :rules="[{ required: true, message: '请选择出生日期' }]"
      />
      
      <van-field
        required
        v-model="form['address']"
        size="large"
        label="现住址"
        
        placeholder="请输入地址"
        :rules="[{ required: true, message: '请输入地址' }]"
      />
       <van-field
        readonly
        required
        clickable
        name="picker"
        :value="pickerValue['profession']"
        label="职业"
        placeholder="点击选择职业"
        @click="showPicker['profession'] = true"
         :rules="[{ required: true, message: '请选择医保类型' }]"

      />
      <van-field
        v-model="form.phoneNumber"
        required
        size="large"
        label="手机号码"
        placeholder="请输入手机号码"
        :rules="[
          {
            required: true,
            message: '手机号码格式不正确',
            validator: certificatePhone,
          },
        ]"
      />
      <van-field
       v-if="wx_pub_id=='1057'"
        v-model="form.Contact"
        required
        size="large"
        label="联系人"
        placeholder="请输入联系人姓名"
      />
      <div class="submit" v-if="ishaveID">
        <van-button
          class="bottom_button"
          round
          block
          type="info"
          native-type="submit"
          size="nomal"
          >建档并绑定</van-button
        >
      </div>
    </van-form>
    <div class="empty"></div>
    <van-popup v-model="showPicker['certificateType']" round position="bottom">
      <van-picker
        show-toolbar
        :columns="IdCardList"
        value-key="name"
        @cancel="showPicker['certificateType'] = false"
        @confirm="(value) => onConfirm(value, 'certificateType')"
      />
    </van-popup>
    <van-popup v-model="showPicker['pactId']" round position="bottom">
      <van-picker
        show-toolbar
        :columns="pactIdOBJ"
        value-key="name"
        @cancel="showPicker['pactId'] = false"
        @confirm="(value) => onConfirm(value, 'pactId')"
      />
    </van-popup>
    <van-popup v-model="showPicker['birthDay']" round position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
        @cancel="showPicker['birthDay'] = false"
        @confirm="(value) => onConfirm(value, 'birthDay')"
      />
    </van-popup>
    <van-popup v-model="showPicker['profession']" round position="bottom">
      <van-picker
        show-toolbar
        :columns="professionOBJ"
        value-key="name"
        @cancel="showPicker['profession'] = false"
        @confirm="(value) => onConfirm(value, 'profession')"
      />
    </van-popup>
    <van-popup v-model="showPicker['nation']" round position="bottom">
      <van-picker
        show-toolbar
        :columns="nationOBJ"
        value-key="name"
        @cancel="showPicker['nation'] = false"
        @confirm="(value) => onConfirm(value, 'nation')"
      />
    </van-popup>
    <van-popup v-model="showPicker['nationalityName']" round position="bottom">
      <van-picker
        show-toolbar
        :columns="nationalityNameOBJ"
        value-key="name"
        @cancel="showPicker['nationalityName'] = false"
        @confirm="(value) => onConfirm(value, 'nationalityName')"
      />
    </van-popup>
   
  </div>
</template>

<script>
import setOptions from "@/mixins/setOption";
import Nav from "@/components/nav.vue";
import provinceOBJ from "@/utils/area.js";
import area from "../../../utils/area1.js";
// import { Picker,Toast } from 'vant';
export default {
  mixins: [setOptions],
  data() {
    return {
      wx_pub_id:"",
      ispath:null,
      area: area,
      ncode: [],
      nname: [],
      value: "",
      showArea: false,
      areaList: provinceOBJ,
      province: {},
      navTitle: "建立医院档案",
      ishaveID: true,
      value: "",
      IdCardList: [],
      pactIdOBJ: [],
      professionOBJ: [],
      nationOBJ: [
        { value: 1, name: "汉族" },
        { value: 2, name: "蒙古族" },
        { value: 3, name: "回族" },
        { value: 4, name: "藏族" },
        { value: 5, name: "维吾尔族" },
        { value: 6, name: "苗族" },
        { value: 7, name: "彝族" },
        { value: 8, name: "壮族" },
        { value: 9, name: "布依族" },
        { value: 10, name: "朝鲜族" },
        { value: 11, name: "满族" },
        { value: 12, name: "侗族" },
        { value: 13, name: "瑶族" },
        { value: 14, name: "白族" },
        { value: 15, name: "土家族" },
        { value: 16, name: "哈尼族" },
        { value: 17, name: "哈萨克族" },
        { value: 18, name: "傣族" },
        { value: 19, name: "黎族" },
        { value: 20, name: "傈僳族" },
        { value: 21, name: "佤族" },
        { value: 22, name: "畲族" },
        { value: 23, name: "高山族" },
        { value: 24, name: "拉祜族" },
        { value: 25, name: "水族" },
        { value: 26, name: "东乡族" },
        { value: 27, name: "纳西族" },
        { value: 28, name: "景颇族" },
        { value: 29, name: "柯尔克孜族" },
        { value: 30, name: "土族" },
        { value: 31, name: "达斡尔族" },
        { value: 32, name: "仫佬族" },
        { value: 33, name: "羌族" },
        { value: 34, name: "布朗族" },
        { value: 35, name: "撒拉族" },
        { value: 36, name: "毛难族" },
        { value: 37, name: "仡佬族" },
        { value: 38, name: "锡伯族" },
        { value: 39, name: "阿昌族" },
        { value: 40, name: "普米族" },
        { value: 41, name: "塔吉克族" },
        { value: 42, name: "怒族" },
        { value: 43, name: "乌孜别克族" },
        { value: 44, name: "俄罗斯族" },
        { value: 45, name: "鄂温克族" },
        { value: 46, name: "崩龙族" },
        { value: 47, name: "保安族" },
        { value: 48, name: "裕固族" },
        { value: 49, name: "京族" },
        { value: 50, name: "塔塔尔族" },
        { value: 51, name: "独龙族" },
        { value: 52, name: "鄂伦春族" },
        { value: 53, name: "赫哲族" },
        { value: 54, name: "门巴族" },
        { value: 55, name: "珞巴族" },
        { value: 56, name: "基诺族" },
      ],
      nationalityNameOBJ: [
        { value: "156", name: "中国" },
        { value: "184", name: "库克群岛" },
        { value: "262", name: "吉布提" },
        { value: "218", name: "厄瓜多尔" },
        { value: "232", name: "厄立特里亚" },
        { value: "234", name: "法罗群岛" },
        { value: "254", name: "法属圭亚那" },
        { value: "598", name: "巴布亚新几内亚" },
        { value: "334", name: "赫德岛和麦克唐纳岛" },
        { value: "400", name: "约旦" },
        { value: "520", name: "瑙鲁" },
        { value: "528", name: "荷兰" },
        { value: "530", name: "荷属安的列斯" },
        { value: "540", name: "新喀里多尼亚" },
        { value: "558", name: "尼加拉瓜" },
        { value: "562", name: "尼日尔" },
        { value: "566", name: "尼日利亚" },
        { value: "574", name: "诺福克岛" },
        { value: "578", name: "挪威" },
        { value: "586", name: "巴基斯坦" },
        { value: "585", name: "帕劳" },
        { value: "275", name: "巴勒斯坦" },
        { value: "446", name: "澳门" },
        { value: "426", name: "莱索托" },
        { value: "466", name: "马里" },
        { value: "500", name: "蒙特塞拉特" },
        { value: "580", name: "北马里亚纳" },
        { value: "270", name: "冈比亚Gambia" },
        { value: "268", name: "格鲁吉亚" },
        { value: "276", name: "德国" },
        { value: "292", name: "直布罗陀" },
        { value: "300", name: "希腊" },
        { value: "304", name: "格陵兰" },
        { value: "316", name: "关岛" },
        { value: "312", name: "瓜德罗普" },
        { value: "12", name: "阿尔及利亚" },
        { value: "458", name: "马来西亚" },
        { value: "584", name: "马绍尔群岛" },
        { value: "175", name: "马约特" },
        { value: "492", name: "摩纳哥" },
        { value: "508", name: "莫桑比克" },
        { value: "162", name: "圣诞岛" },
        { value: "166", name: "科科斯(基林)群岛" },
        { value: "174", name: "科摩罗" },
        { value: "178", name: "刚果(布)" },
        { value: "180", name: "刚果(金)" },
        { value: "480", name: "毛里求斯" },
        { value: "484", name: "墨西哥" },
        { value: "583", name: "密克罗尼西亚联邦" },
        { value: "320", name: "危地马拉" },
        { value: "188", name: "哥斯达黎加" },
        { value: "384", name: "科特迪瓦" },
        { value: "818", name: "埃及" },
        { value: "222", name: "萨尔瓦多" },
        { value: "226", name: "赤道几内亚" },
        { value: "233", name: "爱沙尼亚" },
        { value: "231", name: "埃塞俄比亚" },
        { value: "242", name: "斐济" },
        { value: "246", name: "芬兰" },
        { value: "250", name: "法国" },
        { value: "258", name: "法属波利尼西亚" },
        { value: "260", name: "法属南部领土" },
        { value: "524", name: "尼泊尔" },
        { value: "554", name: "新西兰" },
        { value: "570", name: "纽埃" },
        { value: "512", name: "阿曼" },
        { value: "591", name: "巴拿马" },
        { value: "84", name: "伯利兹" },
        { value: "854", name: "布基纳法索" },
        { value: "158", name: "台湾" },
        { value: "196", name: "塞浦路斯" },
        { value: "238", name: "福克兰群岛(马尔维纳斯)" },
        { value: "646", name: "卢旺达" },
        { value: "654", name: "圣赫勒拿" },
        { value: "659", name: "圣基茨和尼维斯" },
        { value: "666", name: "圣皮埃尔和密克隆" },
        { value: "882", name: "萨摩亚" },
        { value: "498", name: "摩尔多瓦" },
        { value: "496", name: "蒙古" },
        { value: "504", name: "摩洛哥" },
        { value: "104", name: "缅甸" },
        { value: "516", name: "纳米比亚" },
        { value: "620", name: "葡萄牙" },
        { value: "662", name: "圣卢西亚" },
        { value: "690", name: "塞舌尔" },
        { value: "724", name: "西班牙" },
        { value: "780", name: "特立尼达和多巴哥" },
        { value: "548", name: "瓦努阿图" },
        { value: "736", name: "苏丹" },
        { value: "744", name: "斯瓦尔巴群岛" },
        { value: "748", name: "斯威士兰" },
        { value: "752", name: "瑞典" },
        { value: "760", name: "叙利亚" },
        { value: "762", name: "塔吉克斯坦" },
        { value: "834", name: "坦桑尼亚" },
        { value: "674", name: "圣马力诺" },
        { value: "678", name: "圣多美和普林西比" },
        { value: "682", name: "沙特阿拉伯" },
        { value: "694", name: "塞拉利昂" },
        { value: "702", name: "新加坡" },
        { value: "703", name: "斯洛伐克" },
        { value: "705", name: "斯洛文尼亚" },
        { value: "90", name: "所罗门群岛" },
        { value: "706", name: "索马里" },
        { value: "710", name: "南非" },
        { value: "239", name: "南乔治亚岛和南桑德韦奇岛" },
        { value: "144", name: "斯里兰卡" },
        { value: "772", name: "托克劳" },
        { value: "788", name: "突尼斯" },
        { value: "792", name: "土耳其" },
        { value: "31", name: "阿塞拜疆" },
        { value: "600", name: "巴拉圭" },
        { value: "604", name: "秘鲁" },
        { value: "608", name: "菲律宾" },
        { value: "612", name: "皮特凯恩群岛" },
        { value: "616", name: "波兰" },
        { value: "630", name: "波多黎各" },
        { value: "634", name: "卡塔尔" },
        { value: "638", name: "留尼汪" },
        { value: "642", name: "罗马尼亚" },
        { value: "643", name: "俄罗斯联邦" },
        { value: "796", name: "特克斯科斯群岛" },
        { value: "798", name: "图瓦卢" },
        { value: "800", name: "乌干达" },
        { value: "784", name: "阿联酋" },
        { value: "826", name: "英国" },
        { value: "840", name: "美国" },
        { value: "858", name: "乌拉圭" },
        { value: "860", name: "乌兹别克斯坦" },
        { value: "704", name: "越南" },
        { value: "92", name: "英属维尔京群岛" },
        { value: "850", name: "美属维尔京群岛" },
        { value: "732", name: "西撒哈拉" },
        { value: "887", name: "也门" },
        { value: "891", name: "南斯拉夫" },
        { value: "716", name: "津巴布韦" },
        { value: "768", name: "多哥" },
        { value: "152", name: "智利" },
        { value: "344", name: "香港" },
        { value: "686", name: "塞内加尔" },
        { value: "266", name: "加蓬" },
        { value: "288", name: "加纳" },
        { value: "308", name: "格林纳达" },
        { value: "324", name: "几内亚" },
        { value: "36", name: "澳大利亚" },
        { value: "740", name: "苏里南" },
        { value: "756", name: "瑞士" },
        { value: "764", name: "泰国" },
        { value: "776", name: "汤加" },
        { value: "795", name: "土库曼斯坦" },
        { value: "804", name: "乌克兰" },
        { value: "581", name: "美国本土外小岛屿" },
        { value: "862", name: "委内瑞拉" },
        { value: "876", name: "瓦利斯和富图纳" },
        { value: "894", name: "赞比亚" },
        { value: "4", name: "阿富汗" },
        { value: "16", name: "美属萨摩亚" },
        { value: "20", name: "安道尔" },
        { value: "660", name: "安圭拉" },
        { value: "10", name: "南极洲" },
        { value: "28", name: "安提瓜和巴布达" },
        { value: "51", name: "亚美尼亚" },
        { value: "533", name: "阿鲁巴" },
        { value: "44", name: "巴哈马" },
        { value: "48", name: "巴林" },
        { value: "50", name: "孟加拉国" },
        { value: "52", name: "巴巴多斯" },
        { value: "112", name: "白俄罗斯" },
        { value: "56", name: "比利时" },
        { value: "204", name: "贝宁" },
        { value: "60", name: "百慕大" },
        { value: "64", name: "不丹" },
        { value: "68", name: "玻利维亚" },
        { value: "70", name: "波黑" },
        { value: "72", name: "博茨瓦纳" },
        { value: "74", name: "布维岛" },
        { value: "76", name: "巴西" },
        { value: "86", name: "英属印度洋领土" },
        { value: "96", name: "文莱" },
        { value: "100", name: "保加利亚" },
        { value: "108", name: "布隆迪" },
        { value: "116", name: "柬埔寨" },
        { value: "120", name: "喀麦隆" },
        { value: "124", name: "加拿大" },
        { value: "132", name: "佛得角" },
        { value: "136", name: "开曼群岛" },
        { value: "140", name: "中非" },
        { value: "148", name: "乍得" },
        { value: "191", name: "克罗地亚" },
        { value: "192", name: "古巴" },
        { value: "203", name: "捷克" },
        { value: "208", name: "丹麦" },
        { value: "212", name: "多米尼克" },
        { value: "214", name: "多米尼加共和国" },
        { value: "670", name: "圣文森特和格林纳丁斯" },
        { value: "336", name: "梵蒂冈" },
        { value: "626", name: "东帝汶" },
        { value: "624", name: "几内亚比绍" },
        { value: "328", name: "圭亚那" },
        { value: "332", name: "海地" },
        { value: "340", name: "洪都拉斯" },
        { value: "348", name: "匈牙利" },
        { value: "352", name: "冰岛" },
        { value: "356", name: "印度" },
        { value: "360", name: "印度尼西亚" },
        { value: "364", name: "伊朗" },
        { value: "368", name: "伊拉克" },
        { value: "372", name: "爱尔兰" },
        { value: "8", name: "阿尔巴尼亚" },
        { value: "24", name: "安哥拉" },
        { value: "32", name: "阿根廷" },
        { value: "40", name: "奥地利" },
        { value: "376", name: "以色列" },
        { value: "380", name: "意大利" },
        { value: "388", name: "牙买加" },
        { value: "392", name: "日本" },
        { value: "398", name: "哈萨克斯坦" },
        { value: "404", name: "肯尼亚" },
        { value: "296", name: "基里巴斯" },
        { value: "408", name: "朝鲜" },
        { value: "410", name: "韩国" },
        { value: "414", name: "科威特" },
        { value: "417", name: "吉尔吉斯斯坦" },
        { value: "418", name: "老挝" },
        { value: "428", name: "拉脱维亚" },
        { value: "422", name: "黎巴嫩" },
        { value: "430", name: "利比里亚" },
        { value: "434", name: "利比亚" },
        { value: "438", name: "列支敦士登" },
        { value: "440", name: "立陶宛" },
        { value: "442", name: "卢森堡" },
        { value: "807", name: "前南马其顿" },
        { value: "450", name: "马达加斯加" },
        { value: "454", name: "马拉维" },
        { value: "462", name: "马尔代夫" },
        { value: "470", name: "马耳他" },
        { value: "474", name: "马提尼克" },
        { value: "478", name: "毛里塔尼亚" },
      ],
      // provinceOBJ: [],
      showPicker: {
        certificateType: false,
        pactId: false,
        birthDay: false,
        profession: false,
        nation: false,
        province: false,
        nationalityName: false,
      },
      pickerValue: {
        certificateType: "居民身份证",
        pactId: "现金",
        profession: "自由职业者",
        // nation: "汉族",
        nationalityName: "中国",
      },
      form: {
        profession:"51",
        age: "",
        clientName: "",
        genderId: "",
        certificateNo: "",
        birthDay: "",
        address: "",
        phoneNumber: "",
        Contact:""
      },
      minDate: new Date(1888, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      userInfo: [],
      certificateNoTypeName: "",
    };
  },
  components: {
    Nav,
  },
  mounted() {
    this.getcoulms();
    // console.log(this.abc("532501199908050914"))
    this.getrerinfo()
    if(this.$route.query.ispath){
      this.ispath=this.$route.query.ispath
    }
  },
  created() {},
  methods: {
        //判断版本和排版类型
    async getrerinfo() {
      try {
        this.$showLoad();
        let url = "/hospitalconf/index/getdictionaries";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
            this.wx_pub_id = data.data.wx_pub_id;
            this.$hideLoad();
          }
        );
      } catch (error) {
        // console.log(error);
        this.$hideLoad();
      }
    },
    //根据身份证获取年龄
    getage(idcard) {
      let myDate = new Date();
      let month = myDate.getMonth() + 1;
      let day = myDate.getDate();
      let age = myDate.getFullYear() - idcard.substring(6, 10) - 1;
      if (
        idcard.substring(10, 12) < month ||
        (idcard.substring(10, 12) == month &&
          idcard.substring(12, 14) <= day)
      ) {
        age++;
      }
      return age.toString();
    },
    //根据身份证获取地址
    getaddress(idCard) {
      if (!idCard || idCard.length < 6) return "";
      let provinceNo = idCard.substring(0, 2) + "0000";
      let cityNo = idCard.substring(0, 4) + "00";
      let countyNo = idCard.substring(0, 6);

      let provinceName = this.area.province_list[provinceNo];
      // console.log(provinceName)
      let cityName = this.area.city_list[cityNo];
      let countyName = this.area.county_list[countyNo];

      let result =
        (provinceName ? provinceName : "") +
        "" +
        (cityName ? cityName : "") +
        "" +
        (countyName ? countyName : "");

      return result;
    },
    //nav返回
    onClickLeft() {
      this.$router.go(-1);
    },
    getBindFormData() {
      if (
        this.$route.query.clientName ||
        this.$route.query.certificateType ||
        this.$route.query.certificateNo
      ) {
        this.form.clientName = this.$route.query.clientName;
        // this.form.certificateType = this.$route.query.certificateType;
        this.form.age = this.getage(this.$route.query.certificateNo)
        this.form.address = "";
        console.log(this.form.address);
        this.form.certificateNo = this.$route.query.certificateNo;
        this.form.genderId = this.getgenderIDbyIdCard(
          this.$route.query.certificateNo
        );
        this.form.birthDay = this.getBirthdayFromIdCard(
          this.$route.query.certificateNo
        );
      }
    },
    //获取选项卡列表
    async getcoulms() {
      try {
        this.$showLoad();
        // this.isLoad = true
        let url = "/hospitalconf/index/getObjType";
        let data = null;
        await this.$axios_request.request_data(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
            // console.log(data);

            //证件类型
            this.IdCardList = data.data.idCardObj;
            //医保类型
            this.pactIdOBJ = data.data.pactIdOBJ;
            //职业类型
            this.professionOBJ = data.data.professionOBJ;

            // 民族
            // this.nationOBJ =  data.data.nationOBJ;
            // 省/市/县
            // this.provinceOBJ =  data.data.provinceOBJ;
            // console.log(this.provinceOBJ);

            this.getBindFormData();
            this.$hideLoad();
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },

    //身份证输入框失去焦点事件

    //通过身份证号获得性别
    getgenderIDbyIdCard(idcard) {
      if (parseInt(idcard.substr(16, 1)) % 2 == 1) {
        //男
        return "1";
      } else {
        //女
        return "2";
      }
    },
    //通过身份证获取生日
    getBirthdayFromIdCard(idCard) {
      var birthday = "";
      if (idCard != null && idCard != "") {
        if (idCard.length == 18) {
          birthday = idCard.substr(6, 8);
        }

        birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
      }

      return birthday;
    },
    //根据对象value拿name
    findValueByname(value, info) {
      // for (let temp in info) {
      //   if (info[temp].value == value) {
      //     return info[temp].name;
      //   }
      // }
      return info.find((info) => info.value === value).name;
    },
    // 根据KEY拿VALUE
    findkeyByvalue(key, info) {
      return info.find((info) => info.key === key).value;
    },
    //获取地址
    getaddres(idnum) {},
    // 选中类型
    onConfirm(item, type) {
      console.log(type);
      if (type === "birthDay") {
        this.form[type] = this.formatDate(item);
        this.showPicker[type] = false;
        return;
      }
      
      this.pickerValue[type] = item.name;
      this.form[type] = item.value;
      console.log( this.form[type])
      this.showPicker[type] = false;
      if (type === "nation") {
        this.pickerValue[type] = item.name;
        this.form[type] = item.name;
        this.nationId = { nation: item.value };
        this.showPicker[type] = false;
        // console.log(this.nationId)
      }
      if (type === "nationalityName") {
        this.pickerValue[type] = item.name;
        this.form[type] = item.name;
        this.nationalityIds = { nationalityId: item.value };
        console.log(this.nationalityIds);
        this.showPicker[type] = false;
      }
    },
    // 证件号码校验
    certificateNoValidator(value) {
      if (this.form.certificateType === "1")
        return /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/.test(value);
      return true;
    },
    //手机号验证
    certificatePhone(value) {
      return /^1(3|4|5|6|7|8|9)\d{9}$/.test(value);
    },
    // 提交表单
    async submit() {
      try {
        this.$showLoad();
        //注册
        let zc_url = "/medicalcard/createclient";
        console.log(this.form)
        let zc_data = this.form;
        await this.$axios_request.axios_request_body(
          "nodeserver",
          zc_url,
          "POST",
          zc_data,
          (data) => {
            this.$hideLoad();
            if(data.data==400){
              this.$toast.fail('绑卡失败，请稍后重试')
              return
            };
              // console.log("建档：：",data)
              if (data.status === 200) {
                if(this.ispath==1){
                   this.$toast.success("注册并绑定成功");
                setTimeout(() => {
                  this.$router.push('/patient_card_selectuser_querydept');
                }, 1000);
                return
                }
                this.$toast.success("注册并绑定成功");
                setTimeout(() => {
                  this.$router.push('/patient_card_list_D');
                }, 1000);
              } else {
                this.$toast.fail("网络连接失败，请稍后重试");
              }
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
        this.$toast.fail("注册并绑定失败, 请核对信息重试");
      }
    },
    //格式化日期
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  width: 100vw;
  margin-bottom: 15px;
  .top {
    height: 50px;
  }
}
</style>
<style lang="scss">
.band-card {
  .van-cell {
    font-size: 16px;
  }
  .van-cell.van-cell--large {
    padding-top: 15px;
    padding-bottom: 15px;
  }
  .van-field__error-message {
    font-size: 14px;
  }
}
.van-field--disabled .van-field__label {
  color: #646566;
}
// 建档按钮
.submit {
  margin: 0px 0px;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 70px;
  display: flex;
  justify-items: center;
  align-items: center;
  background-color: #ffffff;
  border-top: 1px solid #aaaaaa;
  .bottom_button {
    width: 90%;
    margin: 0px auto;
  }
}
.empty {
  height: 65px;
}
</style>